import axios from "axios";
import { baseURL } from "../constants/Api";

export const fetch_booking_history =  async (email)=>{
    const token = localStorage.getItem("token");
    const appUserId = localStorage.getItem("appUserId");

    let config = {
      method: "post",
      url: `${baseURL}/api/userBookingHistory`,
      headers: {
        Accept: "application/json", 
      },
      data:{
        appUserId 
      }
    };
  
    try {
      const response = await axios.request(config);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }


export const checkRequestStatus = async (reservationId, appUserId)=>{
  let config = {
    method: "post",
    url: `${baseURL}/api/requestStatus`,
    headers: {
      Accept: "application/json", 
    },
    data: {
      reservationId,
      appUserId,
    },
  };

  try {
    const response = await axios.request(config);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}